import { formatFriendlyDate, parseLocalDate } from '../utils/dateUtils';

export type EventSponsor = {
  name: string;
  abbreviation?: string;
  logo?: string;
};

export type EventRecord = {
  id: string;
  startDate: string;
  endDate?: string;
  image?: string;
  images?: string[];
  sponsors?: EventSponsor[];
};

export const isPdf = (file?: string) => file?.toLowerCase().endsWith('.pdf') ?? false;

export const hasEventEnded = (event: EventRecord) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return parseLocalDate(event.endDate || event.startDate) < today;
};

export const getEventImages = (event: EventRecord) => {
  const imagePaths = event.images?.length ? event.images : event.image ? [event.image] : [];

  return imagePaths
    .map((imagePath) => {
      try {
        return require(`../schedule-items/events/${imagePath}`) as string;
      } catch {
        return null;
      }
    })
    .filter((image): image is string => Boolean(image));
};

export const getEventSponsorLogo = (event: EventRecord, logo?: string) => {
  if (!logo) {
    return null;
  }

  const imagePath = event.images?.[0] ?? event.image;
  const eventFolder = imagePath?.split('/')[0] ?? `exampleEvent${event.id}`;
  const sponsorLogoPath = logo.includes('/')
    ? logo
    : `${eventFolder}/event-sponsor-images/${logo}`;

  try {
    return require(`../schedule-items/events/${sponsorLogoPath}`) as string;
  } catch {
    return null;
  }
};

export const formatEventDate = (event: EventRecord) => {
  const startDate = formatFriendlyDate(event.startDate);
  return event.endDate ? `${startDate} - ${formatFriendlyDate(event.endDate)}` : startDate;
};
